import type { FaireProductEntity } from "../../entity_types/product";

export const p_c6vqwv5kqb: FaireProductEntity = {
  token: "p_c6vqwv5kqb",
  type: "product",
  name: "18K NON-TARNISH WATERPROOF STAINLESS STEEL BANGLE |40B5237",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/5f22d6f2213c46f27ce33ceb92c2f4986cc52249685d3c2ad82cbe7a1f6fcfe2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8810a15de859d7de886683c6df8d60ab6434b1590802db0c58fe4476d9576244.jpeg",
    "https://cdn.faire.com/fastly/e6fc01e620663e339414b9b767f017bb29f0358f275b55af7dbb6084e7517b13.jpeg",
    "https://cdn.faire.com/fastly/09744db8c57b95cfdd83806a4d6e1db24a913bc9e778cba3854a4456a865a229.jpeg",
    "https://cdn.faire.com/fastly/79e00372c8cf9e2d2707b464c95a0c7aa33bab9d599a49c069d5124051e4b9e4.jpeg",
    "https://cdn.faire.com/fastly/c1c496491d8ef81aa3b951910522f50195ad22be571aa63e47cdf6e48a81c9f2.jpeg",
    "https://cdn.faire.com/fastly/b826dd3dc29cd847f19147df58c559c509479734521f375333287080ff8dcf2e.jpeg",
    "https://cdn.faire.com/fastly/911ba4c9a3d6b96d90aa56e69f0062ad9f14269598b173f8421ff86b0dc67799.jpeg",
    "https://cdn.faire.com/fastly/c2776b7c6e6f341a12d56d7288536e80f85215a344f22ce82e4408db464b6923.jpeg",
    "https://cdn.faire.com/fastly/2f257d7ac9b6708446ce7dd91712785b200e3bcf89b80c456452cca43be8db1e.jpeg",
    "https://cdn.faire.com/fastly/de70a672bbef260d6683389fe36988d303ec3626b0ac66c8a97992b1a2b16de6.jpeg",
    "https://cdn.faire.com/fastly/b4319113c1689288d8db3c438eb4d52bcb3db95d8241e66d5384a518bb405151.jpeg",
    "https://cdn.faire.com/fastly/24c4eb63e34e66d577ed42405b9a349008f9907103d11e2904108fca8c50ddd2.jpeg",
    "https://cdn.faire.com/fastly/a24514d6c3c055c6a0bb044abc57ff094d71753041f0f6b0ae4a186920ce7bba.jpeg",
    "https://cdn.faire.com/fastly/cf5a05de85704af3d4e77b228a90de9c44b5ec59baae6562a0359f2e265baa61.jpeg",
    "https://cdn.faire.com/fastly/9ea057a2d39f347e74c8db5e3eb8b4b63515bba12975c6a48f7f1e4c5798fdde.jpeg",
    "https://cdn.faire.com/fastly/a2773602666980cd2c89d1289f49d9c9fd099c005f6a432d40c3fc67ff6efcee.jpeg",
  ],
  priceDollars: 2.08,
  description:
    "The 18K Gold tarnish-resistant gold-plated stainless steel bangles. Mix of smooth polished, twisted rope, and subtle wavy/hammered designs. Perfect for everyday stacking, minimalist style, or layering. Slip-on style, Hypoallergenic, waterproof, and highly durable. \n\nPRICE PER 1PC BANGLE\n\nProduct Details:\nclasp: Slip on\nMetal finish: Stainless Steel 18K Gold, Silver\nproduct: Lead & Nickel Compliant\nanti-tarnish:  Tarnish Free, Non-Tarnish\n\nReal Gold Dipped Bracelet\nStainless Steel Bracelet\nHypoallergenic Bracelet\nTarnish-Free Bracelet\nNon-Tarnish Bracelet\nWater Proof Bracelet\nWater Resistant Bracelet\nSweatproof Jewelry\nFade Resistant Bracelet\nAnti-oxidation \nPVD Coating\n",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:27.526Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
